import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_status_multi_camera",
  "use": "icon-icon_status_multi_camera-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" overflow=\"visible\" id=\"icon-icon_status_multi_camera\">\n<g>\n\t<path d=\"M7,37h29V16H7V37z M18,20.5l9.5,6l-9.5,6V20.5z\" />\n\t<polygon points=\"15,11 15,13 39,13 39,30 41,30 41,11 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol